<template>
  <div class="page-wrapper">
    <Header/>
    <main class="main">
      <slot/>
    </main>
    <Footer/>
    <Functional/>
    <ToUpButton/>
  </div>
</template>

<script setup>

</script>


<style lang="scss" scoped>
@use '../assets/scss/main.scss';

</style>
